import BaseApi from './baseApi';
import IOutbound from '../models/IOutbound';
import IAuthentication from '../models/IAuthentication';
import { EMPTY_GUID } from '../../config/constants';
import IExciseGoodsPreview from '../models/IExciseGoodsPreview';
export default class OutboundApi extends BaseApi {
    idUser : string = "";
    idCompany : string = "";
    constructor() {
        super("dataaccess", "Outbounds");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.idCompany = userFromStorage.idCompany;
    }

    async GetOutbounds(idCompany: string) : Promise<IOutbound[]> {
        let json : string = "";
        if (idCompany === EMPTY_GUID) {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithIdCompany(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outbounds: IOutbound[] = [];
            outbounds = response.data as IOutbound[];
            return outbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetOutboundsSubstractMonth(idCompany: string) : Promise<IOutbound[]> {
        let json : string = "";
        if (idCompany === EMPTY_GUID) {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithIdCompanyAndDate(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outbounds: IOutbound[] = [];
            outbounds = response.data as IOutbound[];
            return outbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetOutboundsCompleted(idCompany: string) : Promise<IOutbound[]> {
        let json : string = "";
        if (idCompany === EMPTY_GUID) {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithOnlyCompleted(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outbounds: IOutbound[] = [];
            outbounds = response.data as IOutbound[];
            return outbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetOutboundsCodes(idCompany: string) : Promise<IOutbound[]> {
        let json : string = this.getJsonReadCodes(idCompany);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outbounds: IOutbound[] = [];
            outbounds = response.data as IOutbound[];
            return outbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveOutbound(outbound: IOutbound) : Promise<string> {
        const json = this.getJsonSave(outbound);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateOutbound(outbound: IOutbound) : Promise<boolean> {
        const json = this.getJsonUpdate(outbound);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteOutbound(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async GetOutboundsByDate(time: string, idCompanyDestination: string) : Promise<IOutbound[]> {
        let json : string = this.getJsonReadByTimeSlot(time, idCompanyDestination);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outbounds: IOutbound[] = [];
            outbounds = response.data as IOutbound[];
            return outbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetOutboundsByDateOtherCompanies(time: string, idCompanyDestination: string) {
        let json : string = this.getJsonReadByTimeSlotOtherCompany(time, idCompanyDestination);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outbounds: IOutbound[] = [];
            outbounds = response.data as IOutbound[];
            return outbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetOutboundsByDateExternCompanies(time: string, idCompanyDestination: string) {
        let json : string = this.getJsonReadByTimeSlotExternCompany(time, idCompanyDestination);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outbounds: IOutbound[] = [];
            outbounds = response.data as IOutbound[];
            return outbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async getExciseGoodsPreview(initialDate: string, endDate: string): Promise<IExciseGoodsPreview[]> {
        const json = this.getExciseGoodsPreviewJson(initialDate, endDate);
        const response = await this.api.post('ExecWithResults', json);

        if (!response || !response.isSuccess || !response.data) {
            return [];
        }

        const rows = response.data as any[];
        const grouped: Record<string, IExciseGoodsPreview> = {};

        rows.forEach((row: any) => {
            const outboundId = row.idOutbound;
            if (!outboundId) return;

            if (!grouped[outboundId]) {
                grouped[outboundId] = {
                    id: outboundId,
                    outboundCode: row.outboundCode || "",
                    outboundType: row.outboundType || "",
                    dateOut: row.dateOut || "",
                    customerName: row.customerName || "",
                    customerCountry: row.customerCountry || "",
                    details: []
                };
            }

            grouped[outboundId].details.push({
                id: row.idOutboundDetail || "",
                goodName: row.goodName || "",
                goodCode: row.goodCode || "",

                drinkCategory: row.drinkCategory || "",
                customsCodeUsed: row.customsCodeUsed || "",
                alcoholPercentage: Number(row.alcoholPercentage || 0),
                litersPerUnit: Number(row.litersPerUnit || 0),

                rateAmountUsed: Number(row.rateAmountUsed || 0),
                exciseTariff: Number(row.exciseTariff || 0),

                calculatedLiters: Number(row.calculatedLiters || 0),
                quantity: Number(row.quantity || 0),

                unit: row.unit || "",
                weight: Number(row.weight || 0),

                calculatedExciseAmount: Number(row.calculatedExciseAmount || 0),
                totalExcise: Number(row.totalExcise || 0)
            });
        });

        return Object.values(grouped);
    }

    private getExciseGoodsPreviewJson(initialDate: string, endDate: string): any {
        return {
            spname: "dbo.GET_EXCISE_GOODS_PREVIEW",
            parameters: [
                {
                    Item1: "InitialDate",
                    Item2: initialDate
                },
                {
                    Item1: "EndDate",
                    Item2: endDate
                },
                {
                    Item1: "CompanyId",
                    Item2: this.idCompany
                }
            ]
        };
    }

    private getJsonReadByTimeSlot(time: string, idCompanyDestination: string) : any {
        const json = {
            "fields": [{
                "Item1": "Outbounds",
                "Item2": "id"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "Name as customerName"
            }, {
                "Item1": "Outbounds",
                "Item2": "customerDestination"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusOutbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Outbounds",
                "Item2": "code"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut"
            }, {
                "Item1": "Outbounds",
                "Item2": "dossierNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "liters"
            }, {
                "Item1": "Outbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "weight"
            }, {
                "Item1": "Outbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "deliveriesNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "description"
            }, {
                "Item1": "Outbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Outbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Outbounds",
                "Item2": "agp"
            }, {
                "Item1": "Outbounds",
                "Item2": "referenceInboundCode"
            }, {
                "Item1": "Outbounds",
                "Item2": "createdDate"
            }, {
                "Item1": "Outbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Outbounds",
                "Item2": "idListTypesOutbounds"
            }, {
                "Item1": "ListTypesOutbounds",
                "Item2": "name as idListTypesOutboundsName"
            }, {
                "Item1": "Outbounds",
                "Item2": "customerDestinationCountry"
            }],
            "tables": [{
                "Item1": "Outbounds"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "ListTypesOutbounds"
            }],
            "joins": [{
                "Item1": "Outbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "Outbounds",
                "Item2": "IdListTypesOutbounds",
                "Item3": "ListTypesOutbounds",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut",
                "Item3": "=",
                "Item4": time,
                "Item5": "AND"
            }, {
                "Item1": "(Outbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": this.idCompany,
                "Item5": "AND"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompanyDestination,
                "Item5": ")"
            }]
        };
        return json;
    }

    private getJsonReadByTimeSlotOtherCompany(time: string, idCompanyDestination: string) : any {
        const json = {
            "fields": [{
                "Item1": "Outbounds",
                "Item2": "id"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "Name as customerName"
            }, {
                "Item1": "Outbounds",
                "Item2": "customerDestination"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusOutbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Outbounds",
                "Item2": "code"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut"
            }, {
                "Item1": "Outbounds",
                "Item2": "dossierNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "liters"
            }, {
                "Item1": "Outbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "weight"
            }, {
                "Item1": "Outbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "deliveriesNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "description"
            }, {
                "Item1": "Outbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Outbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Outbounds",
                "Item2": "agp"
            }, {
                "Item1": "Outbounds",
                "Item2": "referenceInboundCode"
            }, {
                "Item1": "Outbounds",
                "Item2": "createdDate"
            }, {
                "Item1": "Outbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Outbounds",
                "Item2": "idListTypesOutbounds"
            }, {
                "Item1": "ListTypesOutbounds",
                "Item2": "name as idListTypesOutboundsName"
            }, {
                "Item1": "Outbounds",
                "Item2": "customerDestinationCountry"
            }],
            "tables": [{
                "Item1": "Outbounds"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "ListTypesOutbounds"
            }],
            "joins": [{
                "Item1": "Outbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "Outbounds",
                "Item2": "IdListTypesOutbounds",
                "Item3": "ListTypesOutbounds",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut",
                "Item3": "=",
                "Item4": time,
                "Item5": "AND"
            }, {
                "Item1": "(Outbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompanyDestination,
                "Item5": "AND"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompanyDestination,
                "Item5": ")"
            }]
        };
        return json;
    }

    private getJsonReadByTimeSlotExternCompany(time: string, idCompanyDestination: string) : any {
        const json = {
            "fields": [{
                "Item1": "Outbounds",
                "Item2": "id"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "Name as customerName"
            }, {
                "Item1": "Outbounds",
                "Item2": "customerDestination"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusOutbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Outbounds",
                "Item2": "code"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut"
            }, {
                "Item1": "Outbounds",
                "Item2": "dossierNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "liters"
            }, {
                "Item1": "Outbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "weight"
            }, {
                "Item1": "Outbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "deliveriesNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "description"
            }, {
                "Item1": "Outbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Outbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Outbounds",
                "Item2": "agp"
            }, {
                "Item1": "Outbounds",
                "Item2": "referenceInboundCode"
            }, {
                "Item1": "Outbounds",
                "Item2": "createdDate"
            }, {
                "Item1": "Outbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Outbounds",
                "Item2": "idListTypesOutbounds"
            }, {
                "Item1": "ListTypesOutbounds",
                "Item2": "name as idListTypesOutboundsName"
            }, {
                "Item1": "Outbounds",
                "Item2": "customerDestinationCountry"
            }],
            "tables": [{
                "Item1": "Outbounds"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "ListTypesOutbounds"
            }],
            "joins": [{
                "Item1": "Outbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "Outbounds",
                "Item2": "IdListTypesOutbounds",
                "Item3": "ListTypesOutbounds",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut",
                "Item3": "=",
                "Item4": time,
                "Item5": "AND"
            }, {
                "Item1": "(Outbounds",
                "Item2": "idCompanySource",
                "Item3": "<>",
                "Item4": this.idCompany,
                "Item5": "AND"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompanyDestination,
                "Item5": ")"
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "Outbounds",
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(Outbound: IOutbound) : any {
        const parseDecimal = (value: any) => {
            if (value === null || value === undefined) return 0;

            // Convertir a string y reemplazar comas decimales
            const normalized = value.toString().replace(',', '.').trim();

            // Si no es numérico, devolver 0
            if (normalized === '' || isNaN(Number(normalized))) return 0;

            return Number(normalized);
        };
        
        const json = {
            "fieldsvalues": [{
                "Item1": "idCompanySource",
                "Item2": Outbound.idCompanySource
            }, {
                "Item1": "idCompanyDestination",
                "Item2": Outbound.idCompanyDestination
            }, {
                "Item1": "idCustomer",
                "Item2": Outbound.idCustomer
            }, {
                "Item1": "customerDestination",
                "Item2": Outbound.customerDestination
            }, {
                "Item1": "idStatus",
                "Item2": Outbound.idStatus
            }, {
                "Item1": "code",
                "Item2": Outbound.code
            }, {
                "Item1": "dateOut",
                "Item2": Outbound.dateOut
            }, {
                "Item1": "dossierNumber",
                "Item2": Outbound.dossierNumber
            }, {
                "Item1": "liters",
                "Item2": parseDecimal(Outbound.liters)
            }, {
                "Item1": "sealNumber",
                "Item2": Outbound.sealNumber
            }, {
                "Item1": "weight",
                "Item2": parseDecimal(Outbound.weight)
            }, {
                "Item1": "containerNumber",
                "Item2": Outbound.containerNumber
            }, {
                "Item1": "deliveriesNumber",
                "Item2": Outbound.deliveriesNumber
            }, {
                "Item1": "description",
                "Item2": Outbound.description
            }, {
                "Item1": "orderNumber",
                "Item2": Outbound.orderNumber
            }, {
                "Item1": "StartTime",
                "Item2": Outbound.startTime
            }, {
                "Item1": "EndTime",
                "Item2": Outbound.endTime
            }, {
                "Item1": "DateChanged",
                "Item2": Outbound.dateChanged
            }, {
                "Item1": "entrepot",
                "Item2": Outbound.entrepot
            }, {
                "Item1": "agp",
                "Item2": Outbound.agp
            }, {
                "Item1": "referenceInboundCode",
                "Item2": Outbound.referenceInboundCode
            }, {
                "Item1": "codeDestination",
                "Item2": Outbound.codeDestination
            }, {
                "Item1": "customerDestinationCountry",
                "Item2": Outbound.customerDestinationCountry
            }, {
                "Item1": "idListTypesOutbounds",
                "Item2": Outbound.idListTypesOutbounds
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "Outbounds"
        };
        return json;
    }

    private getJsonUpdate(Outbound: IOutbound) : any {
        const parseDecimal = (value: any) => {
            if (value === null || value === undefined) return 0;

            // Convertir a string y reemplazar comas decimales
            const normalized = value.toString().replace(',', '.').trim();

            // Si no es numérico, devolver 0
            if (normalized === '' || isNaN(Number(normalized))) return 0;

            return Number(normalized);
        };
        const json = {
            "fieldsvalues": [{
                "Item1": "idCompanySource",
                "Item2": Outbound.idCompanySource
            }, {
                "Item1": "idCompanyDestination",
                "Item2": Outbound.idCompanyDestination
            }, {
                "Item1": "idCustomer",
                "Item2": Outbound.idCustomer
            }, {
                "Item1": "customerDestination",
                "Item2": Outbound.customerDestination
            }, {
                "Item1": "idStatus",
                "Item2": Outbound.idStatus
            }, {
                "Item1": "code",
                "Item2": Outbound.code
            }, {
                "Item1": "dateOut",
                "Item2": Outbound.dateOut
            }, {
                "Item1": "dossierNumber",
                "Item2": Outbound.dossierNumber
            }, {
                "Item1": "liters",
                "Item2": parseDecimal(Outbound.liters)
            }, {
                "Item1": "sealNumber",
                "Item2": Outbound.sealNumber
            }, {
                "Item1": "weight",
                "Item2": parseDecimal(Outbound.weight)
            }, {
                "Item1": "containerNumber",
                "Item2": Outbound.containerNumber
            }, {
                "Item1": "deliveriesNumber",
                "Item2": Outbound.deliveriesNumber
            }, {
                "Item1": "description",
                "Item2": Outbound.description
            }, {
                "Item1": "orderNumber",
                "Item2": Outbound.orderNumber
            }, {
                "Item1": "StartTime",
                "Item2": Outbound.startTime
            }, {
                "Item1": "EndTime",
                "Item2": Outbound.endTime
            }, {
                "Item1": "DateChanged",
                "Item2": Outbound.dateChanged
            }, {
                "Item1": "Entrepot",
                "Item2": Outbound.entrepot
            }, {
                "Item1": "Agp",
                "Item2": Outbound.agp
            }, {
                "Item1": "ReferenceInboundCode",
                "Item2": Outbound.referenceInboundCode
            }, {
                "Item1": "codeDestination",
                "Item2": Outbound.codeDestination
            }, {
                "Item1": "customerDestinationCountry",
                "Item2": Outbound.customerDestinationCountry
            }, {
                "Item1": "idListTypesOutbounds",
                "Item2": Outbound.idListTypesOutbounds
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "Outbounds",
            "keyvalue": Outbound.id
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "Outbounds",
                "Item2": "id"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "Name as customerName"
            }, {
                "Item1": "Outbounds",
                "Item2": "customerDestination"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusOutbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Outbounds",
                "Item2": "code"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut"
            }, {
                "Item1": "Outbounds",
                "Item2": "dossierNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "liters"
            }, {
                "Item1": "Outbounds",
                "Item2": "weight"
            }, {
                "Item1": "Outbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "deliveriesNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "description"
            }, {
                "Item1": "Outbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Outbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Outbounds",
                "Item2": "agp"
            }, {
                "Item1": "Outbounds",
                "Item2": "referenceInboundCode"
            }, {
                "Item1": "Outbounds",
                "Item2": "createdDate"
            }, {
                "Item1": "Outbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Outbounds",
                "Item2": "idListTypesOutbounds"
            }, {
                "Item1": "ListTypesOutbounds",
                "Item2": "name as ListTypesOutboundsName"
            }, {
                "Item1": "Outbounds",
                "Item2": "customerDestinationCountry"
            }],
            "tables": [{
                "Item1": "Outbounds"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "ListTypesOutbounds"
            }],
            "joins": [{
                "Item1": "Outbounds",
                "Item2": "idCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "Outbounds",
                "Item2": "IdListTypesOutbounds",
                "Item3": "ListTypesOutbounds",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus",
                "Item3": "NOT IN",
                "Item4": "(SELECT ID FROM ListStatusOutbounds WHERE Name = 'Completed')"
            }]
        };
        return json;
    }

    private getJsonReadWithIdCompany(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Outbounds",
                "Item2": "id"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "Name as customerName"
            }, {
                "Item1": "Outbounds",
                "Item2": "customerDestination"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusOutbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Outbounds",
                "Item2": "code"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut"
            }, {
                "Item1": "Outbounds",
                "Item2": "dossierNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "liters"
            }, {
                "Item1": "Outbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "weight"
            }, {
                "Item1": "Outbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "deliveriesNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "description"
            }, {
                "Item1": "Outbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Outbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Outbounds",
                "Item2": "agp"
            }, {
                "Item1": "Outbounds",
                "Item2": "referenceInboundCode"
            }, {
                "Item1": "Outbounds",
                "Item2": "createdDate"
            }, {
                "Item1": "Outbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Outbounds",
                "Item2": "idListTypesOutbounds"
            }, {
                "Item1": "ListTypesOutbounds",
                "Item2": "name as ListTypesOutboundsName"
            }, {
                "Item1": "Outbounds",
                "Item2": "customerDestinationCountry"
            }],
            "tables": [{
                "Item1": "Outbounds"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "ListTypesOutbounds"
            }],
            "joins": [{
                "Item1": "Outbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "Outbounds",
                "Item2": "IdListTypesOutbounds",
                "Item3": "ListTypesOutbounds",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus",
                "Item3": "NOT IN",
                "Item4": "(SELECT ID FROM ListStatusOutbounds WHERE Name = 'Completed')",
                "Item5": "AND"
            }, {
                "Item1": "(Outbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }

    private getJsonReadCodes(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Outbounds",
                "Item2": "id"
            }, {
                "Item1": "Outbounds",
                "Item2": "code"
            }, {
                "Item1": "Outbounds",
                "Item2": "codeDestination"
            }],
            "tables": [{
                "Item1": "Outbounds"
            }],
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "(Outbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Outbounds",
                "Item2": "Id",
                "Item3": "IN",
                "Item4": "(SELECT IdOutbound FROM OutboundsDeliveryNotes WHERE IdWarehouse IN (SELECT IdWarehouse FROM WarehousesShared WHERE idWarehouse = OutboundsDeliveryNotes.IdWarehouse) AND Deleted = 0)",
                "Item5": "OR"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }

    private getJsonReadWithIdCompanyAndDate(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Outbounds",
                "Item2": "id"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "Name as customerName"
            }, {
                "Item1": "Outbounds",
                "Item2": "customerDestination"
            }, {
                "Item1": "Outbounds",
                "Item2": "customerDestinationCountry"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusOutbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Outbounds",
                "Item2": "code"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut"
            }, {
                "Item1": "Outbounds",
                "Item2": "dossierNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "liters"
            }, {
                "Item1": "Outbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "weight"
            }, {
                "Item1": "Outbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "deliveriesNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "description"
            }, {
                "Item1": "Outbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Outbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Outbounds",
                "Item2": "agp"
            }, {
                "Item1": "Outbounds",
                "Item2": "referenceInboundCode"
            }, {
                "Item1": "Outbounds",
                "Item2": "createdDate"
            }, {
                "Item1": "Outbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Outbounds",
                "Item2": "idListTypesOutbounds"
            }, {
                "Item1": "ListTypesOutbounds",
                "Item2": "name as ListTypesOutboundsName"
            }],
            "tables": [{
                "Item1": "Outbounds"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "ListTypesOutbounds"
            }],
            "joins": [{
                "Item1": "Outbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "Outbounds",
                "Item2": "IdListTypesOutbounds",
                "Item3": "ListTypesOutbounds",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut",
                "Item3": ">",
                "Item4": this.subtractMonths(1),
                "Item5": "AND"
            }, {
                "Item1": "(Outbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }

    private subtractMonths(numOfMonths: number, date = new Date()) {
        date.setMonth(date.getMonth() - numOfMonths);
        return date;
    }

    private getJsonReadWithOnlyCompleted(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Outbounds",
                "Item2": "id"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "Name as customerName"
            }, {
                "Item1": "Outbounds",
                "Item2": "customerDestination"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusOutbounds where id = IdStatus) as statusName"
            }, {
                "Item1": "Outbounds",
                "Item2": "code"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateOut"
            }, {
                "Item1": "Outbounds",
                "Item2": "dossierNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "liters"
            }, {
                "Item1": "Outbounds",
                "Item2": "containerNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "weight"
            }, {
                "Item1": "Outbounds",
                "Item2": "sealNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "deliveriesNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "description"
            }, {
                "Item1": "Outbounds",
                "Item2": "orderNumber"
            }, {
                "Item1": "Outbounds",
                "Item2": "startTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "endTime"
            }, {
                "Item1": "Outbounds",
                "Item2": "dateChanged"
            }, {
                "Item1": "Outbounds",
                "Item2": "entrepot"
            }, {
                "Item1": "Outbounds",
                "Item2": "agp"
            }, {
                "Item1": "Outbounds",
                "Item2": "referenceInboundCode"
            }, {
                "Item1": "Outbounds",
                "Item2": "createdDate"
            }, {
                "Item1": "Outbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Outbounds",
                "Item2": "idListTypesOutbounds"
            }, {
                "Item1": "ListTypesOutbounds",
                "Item2": "name as ListTypesOutboundsName"
            }, {
                "Item1": "Outbounds",
                "Item2": "customerDestinationCountry"
            }],
            "tables": [{
                "Item1": "Outbounds"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "ListTypesOutbounds"
            }],
            "joins": [{
                "Item1": "Outbounds",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "Outbounds",
                "Item2": "IdListTypesOutbounds",
                "Item3": "ListTypesOutbounds",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Outbounds",
                "Item2": "idStatus",
                "Item3": "IN",
                "Item4": "(SELECT ID FROM ListStatusOutbounds WHERE Name = 'Completed')",
                "Item5": "AND"
            }, {
                "Item1": "(Outbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }
}
